"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseBooleanDef = void 0;
function parseBooleanDef() {
    return {
        type: "boolean",
    };
}
exports.parseBooleanDef = parseBooleanDef;
